import Joi from '@hapi/joi';
import { depotStatsSchema } from '../routes/validate';

const sectionSchema = Joi.object({
  sectionCode: Joi.number().required(),
  sectionName: Joi.string().required(),
  shiftManagerName: Joi.string().allow('').required(),
  shiftManagerCode: Joi.string().allow('').required(),
  sectionStats: Joi.object({
    stops: Joi.number().allow(null),
    parcels: Joi.number().allow(null),
    collections: Joi.number().allow(null),
    totalRoutes: Joi.number().required(),
    totalStops: Joi.number().required(),
    totalParcels: Joi.number().required(),
    stopPerRoute: Joi.number().required(),
    totalParcelsOfd: Joi.number().required(),
    totalCollections: Joi.number().required(),
    totalExceptionRoutes: Joi.number().required(),
    totalExceptions: Joi.number().required(),
    averageScanTime: Joi.number().required(),
    averageDutyTime: Joi.number().required(),
    averageOpportunityTime: Joi.number().required(),
  }).required(),
  routeStatus: Joi.object({
    departedTotal: Joi.number().required(),
    departedPercentage: Joi.number().required(),
    loadingTotal: Joi.number().required(),
    loadingPercentage: Joi.number().required(),
    downloadedTotal: Joi.number().required(),
    downloadedPercentage: Joi.number().required(),
    readyTotal: Joi.number().required(),
    readyPercentage: Joi.number().required(),
    openTotal: Joi.number().required(),
    openPercentage: Joi.number().required(),
    inBuildTotal: Joi.number().required(),
    inBuildPercentage: Joi.number().required(),
    offlineTotal: Joi.number().required(),
    offlinePercentage: Joi.number().required(),
  }).required(),
});

const defaultRouteSchema = Joi.object({
  routeId: Joi.string().required(),
  routeCode: Joi.string().required(),
  routeName: Joi.string().required(),
  totalStops: Joi.number().required(),
  totalParcels: Joi.number().required(),
});

const schema = Joi.object({
  section: Joi.array().items(sectionSchema).required(),
  defaultRoutes: Joi.array().items(defaultRouteSchema),
  depotStats: depotStatsSchema.required(),
});

export default schema;
